import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// @mui
import {
  Link,
  Stack,
  // IconButton,
  // InputAdornment,
  TextField,
  Alert,
  // Card
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
// import Iconify from "../../../components/iconify";
import PostRequest from "../../../components/apiConnections/postRequest";
// ----------------------------------------------------------------------
// import { setLocalStoarge } from "../../../components/common/allFunctions";

export default function ForgetPasswordForm() {
  const navigate = useNavigate();
  // const [showPassword, setShowPassword] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [alertData, setAlertData] = useState({});

  useEffect(() => {
    if (alertData.showalert) {
      setTimeout(() => {
        setAlertData({});
      }, 5000);
    }
  }, [alertData]);

  const do_forget = async (e) => {
    e.preventDefault();
    setAlertData({
      alerttype: "info",
      showalert: true,
      message: "Please wait...",
    });
    try {
      const { email } = inputValues;
      if(email === '' || email === undefined)
      {
        setAlertData({
          alerttype: "error",
          showalert: true,
          message: "Please enter valid email address.",
        });
        return false;
      }
      const payload = {
        email: email,
        roleId: 1,
      };
      const userResult = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_FORGET_PASSWORD_ENDPOINT}`,
        payload
      );
      if (userResult && userResult.status === 200) {
        if (userResult.data.code === 200) {
            setAlertData({
              alerttype: "success",
              showalert: true,
              message: "You will receive an email containing a link to reset the password..",
            });
            setTimeout(() => {
              navigate("/", { replace: true });
            }, 3000);
         }
         else {
            setAlertData({
              alerttype: "error",
              showalert: true,
              message: "Unauthorized user.",
            });
          }
      } else {
        setAlertData({
          alerttype: "error",
          showalert: true,
          message: "Unauthorized user.",
        });
      }
    } 
    catch (error) {
      setAlertData({
        alerttype: "error",
        showalert: true,
        message: "Something went wrong.",
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  return (
    <>
      {alertData.showalert ? (
        <Alert sx={{ mb: 2 }} severity={alertData.alerttype}>
          {alertData.message}
        </Alert>
      ) : null}
      <form onSubmit={(e) => do_forget(e)}>
        <Stack spacing={3}>  
        <div className="inputfield">  
          <TextField
            name="email"
            label="Your email"
            placeholder="Email address"
            onChange={handleChange}
            /> 
          </div>  
        </Stack>
        <LoadingButton className='login-buttton-gradient' fullWidth size="large" type="submit" variant="contained" >
          <span> Reset Password</span>
        </LoadingButton>
         <Link href="/" className="achor">
          <h5 className="back-to">
          Back to Login
          </h5>
        </Link>
      </form>
    </>
  );
}
